/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';
import { IParamedic } from 'app/shared/model/paramedic.model';
import { ReferralChargeType } from 'app/shared/model/enumerations/referral-charge-type.model';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { HikeType } from 'app/shared/model/enumerations/hike-type.model';

export interface IParamedicReferralCharge {
  id?: string;
  charge?: number;
  active?: boolean;
  cursor?: number;
  microSec?: number;
  lastUpdated?: number;
  timestampEntry?: number;
  referralChargeType?: keyof typeof ReferralChargeType | null;
  addedByType?: keyof typeof AddedByType | null;
  addedByID?: string;
  modifiedByType?: keyof typeof AddedByType | null;
  modifiedByID?: string;
  emergencyHike?: number | null;
  hishRiskHike?: number | null;
  emergencyHikeType?: keyof typeof HikeType | null;
  hishRiskHikeType?: keyof typeof HikeType | null;
  startDate?: number;
  endDate?: number | null;
  suspended?: boolean;
  draft?: boolean;
  doctor?: IDoctor | null;
  hospital?: IHospital | null;
  scheme?: IPaymentScheme | null;
  procedure?: IHospitalProcedure | null;
  paramedic?: IParamedic | null;
}

export const defaultValue: Readonly<IParamedicReferralCharge> = {
  active: false,
  suspended: false,
  draft: false,
};
